import {
  CheckTokenResponse,
  PasswordResetRequest,
  PasswordResetRequestRequest,
  PasswordResetRequestResponse,
  PasswordResetResponse,
} from '@interfaces/passwordReset.interface';

import api from './';

export const {
  usePasswordResetRequestMutation,
  usePasswordResetMutation,
  useCheckTokenQuery,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    passwordResetRequest: builder.mutation<
      PasswordResetRequestResponse,
      PasswordResetRequestRequest
    >({
      query: ({ body, recaptchaToken }) => ({
        url: 'password-reset/request',
        method: 'POST',
        body,
        headers: {
          'x-grecaptcha': recaptchaToken,
        },
      }),
    }),
    checkToken: builder.query<CheckTokenResponse, string>({
      query: (token) => ({
        url: `password-reset/${token}`,
      }),
    }),
    passwordReset: builder.mutation<
      PasswordResetResponse,
      PasswordResetRequest
    >({
      query: ({ token, body, recaptchaToken }) => ({
        url: `password-reset/${token}`,
        method: 'POST',
        body,
        headers: {
          'x-grecaptcha': recaptchaToken,
        },
      }),
    }),
  }),
});
